import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';

const BROWSE = [['Home', '/'], ['Search', '/search'], ['Wishlist', '/wishlist'], ['Blog', '/blog']] as const;
const CATS = ['Electronics', 'Clothing', 'Books', 'Home', 'Sports'] as const;

const FooterNav: React.FC = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
    <div>
      <div className="flex items-center gap-2 text-white mb-3">
        <ShoppingBag className="w-6 h-6 text-accent" />
        <span className="text-lg font-bold">Amazon Onlines</span>
      </div>
      <p className="text-sm leading-relaxed text-gray-400">
        Discover millions of products at great prices. We earn a small commission when you purchase through our links at no extra cost to you.
      </p>
      <p>
                {/* Logo */}
                <Link to="/" className="flex items-center shrink-0">
                  <img
                    src="/logo.jpg"
                    alt="Amazon Onlines"
                    className="h-40 w-auto object-contain"
                  />
                </Link>
                </p>
    </div>
    <div>
      <h4 className="text-white font-semibold mb-3 text-sm">Browse</h4>
      <ul className="space-y-2 text-sm">
        {BROWSE.map(([label, to]) => (
          <li key={to}><Link to={to} className="hover:text-white transition-colors">{label}</Link></li>
        ))}
      </ul>
    </div>
    <div>
      <h4 className="text-white font-semibold mb-3 text-sm">Categories</h4>
      <ul className="space-y-2 text-sm">
        {CATS.map((c) => (
          <li key={c}><Link to={`/search?q=${c.toLowerCase()}`} className="hover:text-white transition-colors">{c}</Link></li>
        ))}
      </ul>
    </div>
    <div>
      <h4 className="text-white font-semibold mb-3 text-sm">Legal</h4>
      <ul className="space-y-2 text-sm">
        <li><Link to="/disclosure" className="hover:text-white transition-colors">Affiliate Disclosure</Link></li>
        <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
        <li><Link to="/about" className="hover:text-white transition-colors">About Amazon Onlines</Link></li>
        <li>
          <a href="https://affiliate-program.amazon.com/help/operating/agreement" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
            Amazon Associates Agreement
          </a>
        </li>
      </ul>
    </div>
  </div>
);

export default FooterNav;
